module.exports = __webpack_public_path__ + "static/media/khaled_tweet.ffced00a.png";